import CoinTowHeader from "Components/CoinTow/CoinTowHeader/CoinTowHeader";
import EarnStakeMVR from "Components/CoinTow/EarnStakeMVR/EarnStakeMVR";
import HowWork from "Components/CoinTow/HowWork/HowWork";
import StakeMVR from "Components/CoinTow/StakeMVR/StakeMVR";
import WhatIsMVR from "Components/CoinTow/WhatIsMVR/WhatIsMVR";
import SEO from "Components/SEO";
import WorldOfMetaverse from "Components/WorldOfMetaverse";
import React from "react";

const CoinTow = () => {
    return (
        <div>
            <SEO />
            <CoinTowHeader />
            <WorldOfMetaverse />
            <WhatIsMVR />
            <HowWork />
            <StakeMVR />
            <EarnStakeMVR />
        </div>
    );
};

export default CoinTow;
